// removed by extract-text-webpack-plugin
module.exports = {"LoadingIcon":"LoadingIcon__LoadingIcon___1IrO1","spin":"LoadingIcon__spin___1k8pk","LoadingIconLight":"LoadingIcon__LoadingIconLight___1aDFs","LoadingIconDark":"LoadingIcon__LoadingIconDark___XF4Fx"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/Icons/LoadingIcon/LoadingIcon.less
// module id = 1439
// module chunks = 0 1